import Form from './Form';
import { withInit } from './hoc/Init';

interface IMainContent {
  companyKey: string;
  companyName: string;
  okey: string;
  rkey: string;
  portalId: string;
  contractId: string;
}

function MainContent(props: IMainContent) {
  const headerHeight = 60;

  return (
    <div
      className="MainContent"
      style={{
        width: '100%',
        height: `calc(100% - ${headerHeight}px)`,
        overflow: 'auto'
      }}
    >
      <Form
        companyKey={props.companyKey}
        companyName={props.companyName}
        okey={props.okey}
        rkey={props.rkey}
        portalId={props.portalId}
        contractId={props.contractId}
      />
    </div>
  );
}

export default withInit(MainContent);
